import { ESTIMATE_STATES_IDS } from "../../../../../../components/pages/Handler/constants";

export const getExpendituresUrl = (ids) => {
  let url = `/building/${ids.building}/estimate/${ids.estimateState}/expenditures/`;
  if (ids.estimateState === ESTIMATE_STATES_IDS.DRAFT) {
    url = `/building/${ids.building}/estimate/${ids.estimateState}/sections/${ids.section}/expenditures/`;
  }
  return url;
};